import React from "react";
import EconomicTable from "../EconomicTable";
import { useFundamentalsData } from "../../../context/FundamentalsContext";

const GeopoliticsTab = () => {
    const { filteredRows: rows } = useFundamentalsData();

    const data = rows
        .filter(row => row.Category === "GEOPOLITICS")
        .map(row => {
            let topic = row.Topic;
            if (!topic) return row;
            const upperTopic = topic.toUpperCase().trim();
            if (upperTopic.includes("EVENT")) {
                topic = "International Event";
            } else if (upperTopic.includes("FOREIGN POLICY")) {
                topic = "Foreign Policy (Trade, Defense, Diplomatic)";
            }
            return { ...row, Topic: topic };
        });

    console.log("GeopoliticsTab data:", data);

    const groupDescriptions = {
        "Foreign Policy (Trade, Defense, Diplomatic)": "Economic & Foreign Policy: External economic policies such as trade, defense, diplomatic, and development policies."
    };

    return <EconomicTable data={data} title="Geopolitics Analysis" defaultRowData={{ Category: "GEOPOLITICS", Topic: "International Event" }} groupBy="Topic" groupOrder={["International Event", "Foreign Policy (Trade, Defense, Diplomatic)"]} groupDescriptions={groupDescriptions} useDataHook={useFundamentalsData} showNextRelease={false} />;
};

export default GeopoliticsTab;
